export default function getCanvas(): string {
    const [canvas, context] = makeCanvasContext();

    if (!!(context && canvas.toDataURL)) {
        return canvas.toDataURL();
    } else {
        return "unsupported";
    }
}

function makeCanvasContext(): [HTMLCanvasElement, CanvasRenderingContext2D | null] {
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    return [canvas, canvas.getContext('2d')];
}